(function ($) {
	const isSearchResults = $('body').hasClass('search');
	const searchBtn = $('.search-menu-item > a');
	const searchBtnMobile = $('.search-mobile');
	const form = $('.search-form');
	const searchInput = $('.search-form input[type="search"]');
	const submitInput = $('.search-form input[type="submit"]');

	const disableSubmitInput = () => {
		searchInput.val() === ''
			? submitInput.attr('disabled', true)
			: submitInput.removeAttr('disabled');
	};

	searchBtn.on('click', function (event) {
		event.preventDefault();
		if (!isSearchResults) {
			form.slideToggle('fast');
			searchInput.focus();
		}
	});

	searchBtnMobile.on('click', function (event) {
		event.preventDefault();
		searchBtn.trigger('click');
	});

	disableSubmitInput();
	searchInput.on('input', function () {
		disableSubmitInput();
	});
}(jQuery));